$(window).scroll(function () {
  if ($(window).scrollTop() > 115) {
    $("#wrapper").addClass("fixedHeader");
    $("html").addClass("activeScroll");
  } else {
    $("#wrapper").removeClass("fixedHeader");
    $("html").removeClass("activeScroll");
  }
});

$("#mn-nav").click(function () {
  $(this).toggleClass("open");
  $("#header").toggleClass("open-navbar");
  $("body").toggleClass("noscroll");
});

$(".mn-item")
  .mouseenter(function (e1) {
    var thisItem = $(this);
    clearTimeout(thisItem.data("hoverTimer"));
    var timer = setTimeout(function (e1) {
      if ($(thisItem).hasClass("open")) {
        return;
      } else {
        $(thisItem).addClass("open");
      }
    }, 300);
    thisItem.data("hoverTimer", timer);
  })
  .mouseleave(function (e2) {
    var thisItem = $(this);
    clearTimeout(thisItem.data("hoverTimer"));
    var timer = setTimeout(function (e2) {
      if (!$(thisItem).hasClass("open")) {
        return;
      } else {
        $(thisItem).removeClass("open");
      }
    }, 500);
    thisItem.data("hoverTimer", timer);
  });

$(".a-top").click(function () {
  if ($(this).parents(".mn-item").hasClass("active-mb")) {
    $(this).parents(".mn-item").removeClass("active-mb");
  } else {
    $(".mn-item.active-mb").removeClass("active-mb");
    $(this).parents(".mn-item").addClass("active-mb");
  }
});

$(".show-sub").click(function () {
  if ($(this).parents(".sub-col").hasClass("open")) {
    $(this).parents(".sub-col").removeClass("open");
    $(this).parent("h5").next("ul").slideUp(300);
    $("#header").removeClass("toggle");
  } else {
    $(".sub-col.open ul").slideUp(300);
    $(".sub-col.open").removeClass("open");
    $(this).parents(".sub-col").addClass("open");
    $(this).parent("h5").next("ul").slideDown(300);
    $("#header").addClass("toggle");
  }
});

/*-- home slide --*/
var swiper1 = new Swiper(".first-swiper", {
  pagination: false,
  mousewheel: {
    forceToAxis: true,
  },
  parallax: true,
  slidesPerView: 4,
  spaceBetween: 32,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    280: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
      loop: false,
    },
  },
});

var swiper2 = new Swiper(".news-swiper", {
  pagination: false,
  mousewheel: {
    forceToAxis: true,
  },
  parallax: true,
  slidesPerView: 4,
  spaceBetween: 32,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  breakpoints: {
    280: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    415: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});

// var owl = $('.trending-owl');
//   owl.owlCarousel({
//   margin: 30,
//   loop: true,
//   responsive: {
//     0: {
//       items: 2,
//       margin:16
//     },
//     576: {
//       items: 2,
//       margin:20
//     },
//     1000: {
//       items: 3
//     }
//   }
// })

// $('.ow-left').click(function() {
//   $('.items').trigger('prev.owl.carousel');
// });
// $('.ow-right').click(function() {
//   $('.items').trigger('next.owl.carousel');
// });

// var owl2 = $('.rv-slide');
//   owl2.owlCarousel({
//   margin: 30,
//   loop: true,
//   responsive: {
//     0: {
//       items: 1,
//       margin:15
//     },
//     430: {
//       items: 2,
//       margin:20
//     },
//     1000: {
//       items: 3
//     }
//   }
// })

// $('.ow-leftrv').click(function() {
//   $('.rv-slide').trigger('prev.owl.carousel');
// });
// $('.ow-rightrv').click(function() {
//   $('.rv-slide').trigger('next.owl.carousel');
// });

/*-- filter --*/
$("body").on("click", ".ft-name", function () {
  var isActive = $(this).parent().hasClass("active");
  $(this).next(".ft-dropdown").slideToggle();
  if (isActive) {
    $(this).parent().removeClass("active");
  } else {
    $(this).parent().addClass("active");
  }
});

$(".label-sort").click(function () {
  $(this).next(".list-sort").slideToggle(200);
});

$("body").on("click", ".filter-title", function () {
  if ($(window).width() < 992) {
    $(this).next(".filter-list").slideToggle();
  } else {
    $(this).next(".filter-list").show();
  }
});

$(window).resize(function () {
  if ($(window).width() >= 992) {
    $(".filter-list").show();
  }
});

/*-- product detail slide */
var galleryThumbsPr = new Swiper(".gallery-thumbs", {
  spaceBetween: 10,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  autoplay: false,
  mousewheel: {
    forceToAxis: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 4,
      direction: "horizontal",
    },

    577: {
      slidesPerView: 5,
      direction: "horizontal",
    },
    768: {
      slidesPerView: 5,
      direction: "vertical",
    },
    993: {
      slidesPerView: 5,
      direction: "vertical",
    },
    1440: {
      slidesPerView: 4,
      direction: "vertical",
    },
  },
});
var mySwiper = new Swiper(".gallery-img", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  centeredSlides: true,
  slideToClickedSlide: false,
  autoplay: false,
  pagination: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  keyboard: {
    enabled: true,
  },
  thumbs: {
    swiper: galleryThumbsPr,
  },
  preloadImages: false,
  lazy: true,
});

// 2 of 4 : PHOTOSWIPE #######################################
var initPhotoSwipeFromDOM = function (gallerySelector) {
  var parseThumbnailElements = function (el) {
    var thumbElements = el.childNodes,
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;

    for (var i = 0; i < numNodes; i++) {
      figureEl = thumbElements[i];
      if (figureEl.nodeType !== 1) {
        continue;
      }
      linkEl = figureEl.children[0];
      size = linkEl.getAttribute("data-size").split("x");
      item = {
        src: linkEl.getAttribute("href"),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
      };
      if (figureEl.children.length > 1) {
        item.title = figureEl.children[1].innerHTML;
      }
      if (linkEl.children.length > 0) {
        item.msrc = linkEl.children[0].getAttribute("src");
      }
      item.el = figureEl;
      items.push(item);
    }
    return items;
  };
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  var onThumbnailsClick = function (e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
    var eTarget = e.target || e.srcElement;
    var clickedListItem = closest(eTarget, function (el) {
      return el.tagName && el.tagName.toUpperCase() === "LI";
    });
    if (!clickedListItem) {
      return;
    }
    var clickedGallery = clickedListItem.parentNode,
      childNodes = clickedListItem.parentNode.childNodes,
      numChildNodes = childNodes.length,
      nodeIndex = 0,
      index;
    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }
      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }
    if (index >= 0) {
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  var photoswipeParseHash = function () {
    var hash = window.location.hash.substring(1),
      params = {};
    if (hash.length < 5) {
      return params;
    }
    var vars = hash.split("&");
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split("=");
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  var openPhotoSwipe = function (
    index,
    galleryElement,
    disableAnimation,
    fromURL
  ) {
    var pswpElement = document.querySelectorAll(".pswp")[0],
      gallery,
      options,
      items;

    items = parseThumbnailElements(galleryElement);
    options = {
      closeEl: true,
      captionEl: true,
      fullscreenEl: true,
      zoomEl: true,
      shareEl: false,
      counterEl: false,
      arrowEl: true,
      preloaderEl: true,
      galleryUID: galleryElement.getAttribute("data-pswp-uid"),
      getThumbBoundsFn: function (index) {
        var thumbnail = items[index].el.getElementsByTagName("img")[0],
          pageYScroll =
            window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
    };
    if (fromURL) {
      if (options.galleryPIDs) {
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();

    /* ########### PART 4 - EXTRA CODE  ########### */
    /* EXTRA CODE (NOT FROM photoswipe CORE) - 
  1/2. UPDATE SWIPER POSITION TO THE "CURRENT" ZOOM_IN IMAGE (BETTER UI) */
    gallery.listen("unbindEvents", function () {
      // The index of the current photoswipe slide
      let getCurrentIndex = gallery.getCurrentIndex();
      // Update position of the slider
      mySwiper.slideTo(getCurrentIndex, 0, false);
      // 2/2. Start swiper autoplay (on close - if swiper autoplay is true)
      //mySwiper.autoplay.start();
    });
    // 2/2. Extra Code (Not from photoswipe) - swiper autoplay stop when image in zoom mode (When lightbox is open) */
    gallery.listen("initialZoomIn", function () {
      if (mySwiper.autoplay.running) {
        mySwiper.autoplay.stop();
      }
    });
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);

  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute("data-pswp-uid", i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
};

// execute above function
initPhotoSwipeFromDOM(".my-gallery");

/*-- recommend slide --*/
var swiper3 = new Swiper(".rec-swiper", {
  pagination: false,
  mousewheel: {
    forceToAxis: true,
  },
  parallax: true,
  slidesPerView: 5,
  spaceBetween: 32,
  loop: false,
  breakpoints: {
    280: {
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    415: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
    1025: {
      slidesPerView: 4,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },

    1440: {
      slidesPerView: 5,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});

/*-- faq --*/
$(".faq-item .collapsed").click(function () {
  if ($(this).parents(".faq-item").hasClass("active")) {
    $(this).parents(".faq-item").removeClass("active");
    $(this).next(".collapse").slideUp(300);
  } else {
    $(".faq-item.active .collapse").slideUp(300);
    $(".faq-item.active").removeClass("active");
    $(this).parents(".faq-item").addClass("active");
    $(this).next(".collapse").slideDown(300);
  }
});

// function changeheight() {
//   var readmore = $('.more');
//   if (readmore.text() == 'Read more') {
//       readmore.text("Read less");
//   } else {
//       readmore.text("Read more");
//   }

//   $('.br-text').toggleClass("heightAuto");
//   readmore.toggleClass("active");
// };

$("body").on("click", ".more", function () {
  $(".br-text").toggleClass("heightAuto");
  $(".first-dt").toggleClass("heightAuto");
  $(this).toggleClass("active");
  if ($(this).text() == "Read more") {
    $(this).text("Read less");
  } else {
    $(this).text("Read more");
    let top = document.getElementById("product-description-desktop").offsetTop;
    if ($(window).width() <= 992) {
      top =
        document.getElementById("product-description-mobile").offsetTop - 40;
      if (document.querySelector(".left-detail")) {
        top += document.querySelector(".left-detail").clientHeight;
      }
      if (document.querySelector(".right-detail")) {
        top += document.querySelector(".right-detail").clientHeight;
      }
    }
    if (document.getElementById("shopify-section-sale-top-banner")) {
      top += document.getElementById(
        "shopify-section-sale-top-banner"
      ).clientHeight;
    }
    if (document.getElementById("shopify-section-main-header")) {
      top += document.getElementById(
        "shopify-section-main-header"
      ).clientHeight;
    }
    if (document.querySelector(".breadscrumb")) {
      top += document.querySelector(".breadscrumb").clientHeight;
    }
    $("html, body").animate({ scrollTop: top - 20 }, 500);
  }
});

$("#minimized-state").click(function () {
  $(this).hide();
  $("#lightbox-state").show();
  $("#subscribe-tab").toggleClass("open");
});

$("#subscribetab-lightbox-nothanks-link").click(function () {
  $("#minimized-state").show();
  $("#lightbox-state").hide();
  $("#subscribe-tab").removeClass("open");
});

$("#subscribe-tab-lightbox-state-close").click(function () {
  $("#minimized-state").show();
  $("#lightbox-state").hide();
  $("#subscribe-tab").removeClass("open");
});

$(".subscribe-tab-minimized-state-close").click(function () {
  $("#subscribe-row").hide();
});

$(".back-to-top-wrapper").click(function () {
  $("html, body").animate({ scrollTop: 0 }, 500);
  return false;
});

var swiper4 = new Swiper(".hero-swiper", {
  pagination: false,
  mousewheel: {
    forceToAxis: true,
  },
  parallax: true,
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  speed: 1500,
  autoplay: {
    delay: 8000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper5 = new Swiper(".nav-swiper", {
  pagination: false,
  mousewheel: {
    forceToAxis: true,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  speed: 1500,
  autoplay: {
    delay: 10000,
  },
  navigation: false,
});

var swiper6 = new Swiper(".flash-swiper", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  mousewheel: {
    forceToAxis: true,
  },
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  speed: 1500,
  autoplay: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper7 = new Swiper(".trending-swiper", {
  pagination: false,
  mousewheel: {
    forceToAxis: true,
  },
  slidesPerView: 3,
  spaceBetween: 0,
  loop: true,
  speed: 800,
  autoplay: false,
  navigation: {
    nextEl: ".ow-right",
    prevEl: ".ow-left",
  },
  breakpoints: {
    280: {
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: true,
      autoplay: {
        delay: 8000,
      },
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

var swiper8 = new Swiper(".rv-slide", {
  pagination: false,
  mousewheel: {
    forceToAxis: true,
  },
  slidesPerView: 3,
  loop: true,
  speed: 800,
  autoplay: false,
  navigation: {
    nextEl: ".ow-rightrv",
    prevEl: ".ow-leftrv",
  },
  breakpoints: {
    280: {
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: true,
      autoplay: {
        delay: 8000,
      },
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  var lazyloadImages = document.querySelectorAll("img.lazy");
  var lazyloadThrottleTimeout;

  function lazyload() {
    if (lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function () {
      var scrollTop = window.pageYOffset;
      lazyloadImages.forEach(function (img) {
        if (img.offsetTop < window.innerHeight + scrollTop) {
          img.src = img.dataset.src;
          img.classList.remove("lazy");
        }
      });
      if (lazyloadImages.length == 0) {
        document.removeEventListener("scroll", lazyload);
        window.removeEventListener("resize", lazyload);
        window.removeEventListener("orientationChange", lazyload);
      }
    }, 20);
  }

  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);
});

const blog_swiper1 = new Swiper(".feature-slide", {
  navigation: {
    nextEl: ".rv-next",
    prevEl: ".rv-previous",
  },
  autoplay: {
    delay: 8000,
  },
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    280: {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
      freeMode: false,
      loop: false,
      autoplay: false,
    },
  },
});
